// The shell every page loads: styles, theme, the rail and its flyouts, menus, toasts, the
// confirm dialog, the loading bar, AJAX tables, tooltips, copy buttons and Ctrl K search. Page-specific
// behaviour lives in scripts/pages/<page>.ts, loaded only by the view that needs it.
import '../styles/app.css';
import { onReady } from './core/dom';
import { initTheme } from './core/theme';
import { initLoading } from './core/loading';
import { initToasts } from './core/toast';
import { initConfirm } from './core/confirm';
import { initBulkApprove } from './core/bulk-approve';
import { initTables } from './core/table';
import { initRail } from './core/rail';
import { initMenus } from './core/menu';
import { initTooltips } from './core/tooltip';
import { initCopy } from './core/copy';
import { initForms } from './core/forms';
import { initTours } from './core/tours';
import { initSheets } from './core/sheet';
import { initPalette } from './core/palette';

initLoading();
initConfirm();
initForms();

onReady(() => {
	initTheme();
	initToasts();
	initTables();
	initBulkApprove();
	initRail();
	initMenus();
	initTooltips();
	initCopy();
	initTours();
	initSheets();
	initPalette();
	if (document.querySelector('[data-n-chart]')) import('./core/charts').then((m) => m.renderCharts());
	if (document.querySelector('select[data-n-multi]')) import('./core/multi-select').then((m) => m.initMultiSelects());
});
